import * as React from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { isNullOrUndefined } from '@halo/_utils/is-null-or-undefined'

interface IAntdTableEmptyPlaceholder {
    icon?: React.ReactNode
    text?: string
}

export const AntdTableEmptyPlaceholder = React.memo<IAntdTableEmptyPlaceholder>((props) => (
    <div className="ant-empty ant-empty-normal">
        <div className="ant-empty-image">{!isNullOrUndefined(props.icon) ? <InboxOutlined /> : props.icon}</div>
        <p className="ant-empty-description">{!isNullOrUndefined(props.text) ? 'No Data' : props.text}</p>
    </div>
))
